import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import { CustomerDisplayProvider } from './context/CustomerDisplayContext'
import CustomerDisplayLayout from './CustomerDisplayLayout'
import BackgroundCompanyPage from './pages/BackgroundCompanyPage'
import ShoppingCartPage from './pages/ShoppingCartPage'
import DetailQuotePage from './pages/DetailQuotePage'
import ProductSearchPage from './pages/ProductSearchPage'

export default function CustomerDisplay() {
  const { path } = useRouteMatch()

  return (
    <CustomerDisplayProvider>
      <CustomerDisplayLayout>
        <Switch>
          <Route exact path={path} component={BackgroundCompanyPage} />
          <Route path={`${path}/cart`} component={ShoppingCartPage} />
          <Route path={`${path}/quote`} component={DetailQuotePage} />
          <Route path={`${path}/search`} component={ProductSearchPage} />
        </Switch>
      </CustomerDisplayLayout>
    </CustomerDisplayProvider>
  )
}
